import { Controller } from 'stimulus';

// Swaps the client login panel between its two forms: the instant access link
// request (default) and the email/password login.
export default class extends Controller {
  static targets = ['linkForm', 'passwordForm'];

  showPassword() {
    this.linkFormTarget.classList.add('hide');
    this.passwordFormTarget.classList.remove('hide');
  }

  showLink() {
    this.passwordFormTarget.classList.add('hide');
    this.linkFormTarget.classList.remove('hide');
  }
}
